<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container fluid grid-list-md class="pa-0">
    <v-btn color="info" @click="addNewReminder">新增缴费提醒</v-btn>
    <v-spacer class="my-3"></v-spacer>
    <v-data-table
      ref="datatable"
      :headers="headers"
      :items="dues"
      item-key="dueId"
      hide-actions
      :loading="isLoading"
    >
      <template v-slot:items="props">
        <td style="width:150px;">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <a href="javascript:void(0)" v-on="on" @click="updateDueDate(props.item)">{{ props.item.dueDate }}</a>
            </template>
            <span>编辑缴费时间</span>
          </v-tooltip>
        </td>
        <td style="width:200px;">
          {{
            props.item.smsScheduledAt
              ?dateFormat(new Date(props.item.smsScheduledAt),'YYYY-MM-DD HH:mm:ss')
              :''
          }}
        </td>
        <td style="width: 150px;">{{ props.item.smsStatus?'已提醒':'' }}</td>
        <td>
          <v-tooltip v-if="!props.item.smsStatus&&props.item.smsScheduledAt" bottom>
            <template v-slot:activator="{ on }">
              <v-btn small flat icon color="error" v-on="on" @click="unschedule(props.item)">
                <v-icon small>fa-power-off</v-icon>
              </v-btn>
            </template>
            <span>关闭提醒</span>
          </v-tooltip>
          <v-tooltip v-if="!props.item.smsStatus&&!props.item.smsScheduledAt" bottom>
            <template v-slot:activator="{ on }">
              <v-btn small flat icon color="success" v-on="on" @click="schedule(props.item)">
                <v-icon small>fa-power-off</v-icon>
              </v-btn>
            </template>
            <span>开启提醒</span>
          </v-tooltip>

          <v-tooltip v-if="!isFirmRole" bottom>
            <template v-slot:activator="{ on }">
              <v-btn small flat icon color="error" v-on="on" @click="deleteDue(props.item)">
                <v-icon small>fa-trash-alt</v-icon>
              </v-btn>
            </template>
            <span>删除记录</span>
          </v-tooltip>
          <v-tooltip v-if="!props.item.smsStatus" bottom>
            <template v-slot:activator="{ on }">
              <v-btn small flat icon color="success" v-on="on" @click="sendPaymentNotification(props.item)">
                <v-icon small>fa-paper-plane</v-icon>
              </v-btn>
            </template>
            <span>立即发送缴费提醒</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                small
                flat
                icon
                :color="isNoteEdit&&selectedDueId===props.item.dueId?'error':'orange'"
                v-on="on"
                @click="addNote(props.item)"
              >
                <v-icon small>
                  {{ isNoteEdit&&selectedDueId===props.item.dueId?'fa-calendar-times':'fa-calendar-plus' }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{ isNoteEdit&&selectedDueId===props.item.dueId?'关闭缴费记录':'编辑缴费记录' }}</span>
          </v-tooltip>
        </td>
        <td style="width:140px;">
          <input
            v-model="props.item.paymentAmount"
            type="text"
            class="xn-input"
            :disabled="!(isNoteEdit&&selectedDueId===props.item.dueId)"
          />
        </td>
        <td>
          <input
            v-model="props.item.paymentNotes"
            type="text"
            class="xn-input"
            :disabled="!(isNoteEdit&&selectedDueId===props.item.dueId)"
          />
        </td>
        <td style="width:70px;display: flex;align-items: center;">
          <v-tooltip v-if="isNoteEdit&&selectedDueId===props.item.dueId" bottom>
            <template v-slot:activator="{ on }">
              <v-btn small flat icon color="info" v-on="on" @click="saveNote(props.item)">
                <v-icon small>fa-save</v-icon>
              </v-btn>
            </template>
            <span>保存缴费记录</span>
          </v-tooltip>
          <v-tooltip v-if="!isFirmRole&&props.item.paymentId" bottom>
            <template v-slot:activator="{ on }">
              <v-btn small flat icon color="error" v-on="on" @click="deleteNote(props.item)">
                <v-icon small>fa-backspace</v-icon>
              </v-btn>
            </template>
            <span>删除缴费记录</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>

    <v-dialog v-model="showDatePickerDialog" max-width="500px">
      <v-card>
        <v-card-title>请选择时间</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md class="xn-form">
            <v-layout wrap>
              <v-flex xs6>
                <v-menu
                  v-model="showDueDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dueDate"
                      label="缴费日期"
                      readonly
                      outline
                      solo
                      class="xn-date"

                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dueDate"
                    locale="zh-cn"
                    @input="showDueDate = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs2></v-flex>
              <v-flex xs2>
                <v-btn outline @click="showDatePickerDialog=false">取消</v-btn>
              </v-flex>
              <v-flex xs2>
                <v-btn color="info" :disabled="!dueDate" @click="saveDueDate">保存</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import axios from "../axios";
  import {dateFormat} from "vue-filter-date-format";
  import {EventBus} from "../event";

  export default {
    name: "PaymentReminder",
    props: {
      dues: {
        type: [Array,String],
        default:()=>[],
        required: true
      },
      contractId: {
        type: [Number,String],
        default:()=>-1,
        required: true
      },
    },
    computed: {
      isFirmRole() {
        return this.currentUser.role === 'firm';
      }
    },
    data: () => ({
      isLoading: true,
      showDatePickerDialog: false,
      showDueDate: false,
      dueDate: null,
      headers: [
        {text: "缴费时间", value: "dueDate", sortable: false},
        {text: "提醒时间", value: "", sortable: false},
        {text: "提醒状态", value: "", sortable: false},
        {text: "操作", value: "", sortable: false},
        {text: "缴费金额", value: "", sortable: false},
        {text: "备注", value: "", sortable: false},
        {text: "", value: "", sortable: false},
      ],
      rules: {
        required: value => !!value || value === 0,
        isNumber: value => {
          const pattern = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;  ///^\d+$/
          return pattern.test(value);
        },
      },
      isNoteEdit: false,
      selectedDueId: null,
      loadNotesComplete: false
    }),
    methods: {
      dateFormat: dateFormat,
      saveDueDate() {

        if (this.selectedDueId) {
          //修改
          axios
            .post("/dues/" + this.selectedDueId + "/due-date", {
              dueDate: this.dueDate
            })
            .then(response => {
              //item.dueDate = response.data.dueDate;
              this.showDatePickerDialog = false;
              this.selectedDueId = null;
              this.dueDate = null;
              EventBus.$emit('reloadReminder');
            })
            .catch(reason => {
              this.$confirm(reason.response.data.message, {
                buttonFalseText: null
              });
            });
        } else {
          axios
            .post("/dues", {
              contractId: this.contractId,
              dueDate: this.dueDate
            })
            .then((response) => {
              this.showDatePickerDialog = false;
              //this.dues.push(response.data);
              EventBus.$emit('reloadReminder');
            })
            .catch(reason => {
              this.$confirm(reason.response.data.message, {
                buttonFalseText: null
              });
            });
        }

      },
      addNewReminder() {
        this.showDatePickerDialog = true;
        this.selectedDueId = null;
        this.dueDate = null;
      },
      //更新缴费时间
      updateDueDate(item) {
        this.showDatePickerDialog = true;
        this.selectedDueId = item.dueId;
        this.dueDate = item.dueDate;

      },
      //开启提醒
      schedule(item) {
        axios
          .post("/dues/" + item.dueId + "/schedule")
          .then(response => {
            //item.smsScheduledAt = response.data.smsScheduledAt;
            EventBus.$emit('reloadReminder');
          })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {
              buttonFalseText: null
            });
          });
      },
      //关闭提醒
      unschedule(item) {
        axios
          .post("/dues/" + item.dueId + "/unschedule")
          .then(response => {
            //item.smsScheduledAt = null;
            EventBus.$emit('reloadReminder');
          })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {
              buttonFalseText: null
            });
          });
      },
      //删除整条记录
      deleteDue(item) {
        axios
          .delete("/dues/" + item.dueId)
          .then((response) => {
            // item.paymentId = null;
            // item.amount = null;
            // item.notes = null;
            // for (let i = 0; i < this.dues.length; i++) {
            //   if (this.dues[i].paymentId === item.paymentId) {
            //     this.dues.splice(i, 1);
            //   }
            // }

            EventBus.$emit('reloadReminder');
          })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {
              buttonFalseText: null
            });
          });
      },
      //立即发送缴费提醒
      sendPaymentNotification(item) {
        axios
          .post("/dues/" + item.dueId + "/trigger")
          .then(response => {
            //item.smsStatus = response.data.smsStatus;
            //item.smsScheduledAt = response.data.smsScheduledAt
            EventBus.$emit('reloadReminder');
          })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {
              buttonFalseText: null
            });
          });
      },
      //添加缴费记录
      addNote(item) {
        //('添加缴费记录', item);

        if (this.selectedDueId === item.dueId) {
          //关闭
          this.isNoteEdit = false;
          this.selectedDueId = null;
        } else {
          this.isNoteEdit = true;
          this.selectedDueId = item.dueId;
        }


        for (let due of this.dues) {
          if (!due.paymentId) {
            due.paymentAmount = null;
            due.paymentNotes = null;
          }
        }
      },
      //保存缴费记录
      saveNote(item) {
        if (!this.rules.isNumber(item.paymentAmount)) {
          this.$confirm("金额有误", {buttonFalseText: null}).then(() => {
          });
          return;
        }
        if (!this.rules.required(item.paymentNotes)) {
          this.$confirm("备注不能为空", {buttonFalseText: null}).then(() => {
          });
          return;
        }

        axios
          .post("/dues/" + item.dueId + "/payment", {
            amount: item.paymentAmount,
            notes: item.paymentNotes
          })
          .then((response) => {
            this.isNoteEdit = false;
            this.selectedDueId = null;
            //item.paymentId = response.data.paymentId;

            EventBus.$emit('reloadReminder');
          })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {
              buttonFalseText: null
            });
          });
      },
      //删除缴费记录
      deleteNote(item) {

        axios
          .delete("/dues/" + item.dueId + "/payment")
          .then((response) => {
            // item.paymentId = null;
            // item.amount = null;
            // item.notes = null;

            EventBus.$emit('reloadReminder');
          })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {
              buttonFalseText: null
            });
          });
      },
    },

    created() {

    }
  }
</script>

<style scoped>
  .xn-input {
    border: 1px solid rgba(204, 204, 204, 1) !important;
    background: transparent !important;
    box-shadow: none !important;
    border-radius: 3px !important;
    min-height: 34px !important;
    font-size: 13px !important;
    /*margin-bottom: 0px !important;*/
    margin-top: 1px;
    padding: 0 12px;
    width: 100%;
  }

  .xn-input:disabled {
    border: 1px solid transparent !important;
    margin-top: 1px;
    /*padding: 0;*/
  }
</style>
